import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, IconButton } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import StarIcon from '@material-ui/icons/Star';

import useQueryParams from '../../hooks/useQueryParams';
import useMainContext from '../../hooks/useMainContext';
import { mapEventStatusIDToText } from '../../configs/events';

const actionWrapperWidth = 50;

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: 50,
    display: 'flex',
    borderBottom: `1px solid #e0e0e0`,
  },
  timeSection: {
    display: 'flex',
    flexDirection: 'column',
    //width: '50%',
    minWidth: 100,
    marginTop: 5,
    marginBottom: 5,
    alignItems: 'center',
    justifyContent: 'center',
  },
  itemSection: {
    width: 'calc(100% - 100px)',
    paddingLeft: 10,
    paddingRight: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    //flex: 1
  },
  title: {
    fontSize: 16,
  },
  status: {
    fontSize: 10,
    color: '#929292',
    display: 'flex',
    alignItems: 'center',
  },
  detailWrapper: {
    width: `calc(100% - ${actionWrapperWidth}px)`,
  },
  actionWrapper: {
    width: actionWrapperWidth,
  },
  starIcon: {
    fontSize: 15,
    marginRight: 3,
    fill: `#ffc200`,
  },
}));

function EventItem(props) {
  const classes = useStyles();
  const {
    eventID,
    //exceptionID,
    name,
    //contact,
    color,
    status,
    remarks,
    isAllDay,
    startTime,
    endTime,
  } = props.details;

  // eslint-disable-next-line
  const [queryParams, setQueryParams] = useQueryParams();
  const { handleChange: handleMainContextChange } = useMainContext();

  const handleClick = () => {
    setQueryParams({ 'update-event': eventID });
    handleMainContextChange({
      eventDetailUpdate: props.details,
    });
  };

  const handleDetailClick = () => {
    handleMainContextChange({
      eventStatusUpdate: props.details,
    });
  };

  return (
    <div className={classes.root}>
      <div className={classes.timeSection}>
        {isAllDay ? (
          <div> All Day</div>
        ) : (
          <Fragment>
            <div>{startTime}</div>
            <div>{endTime}</div>
          </Fragment>
        )}
      </div>
      <div
        className={classes.itemSection}
        style={{ borderLeft: `3px solid ${color}` }}
      >
        <div className={classes.detailWrapper} onClick={handleDetailClick}>
          <Typography className={classes.name} style={{ color: color }} noWrap>
            {name}
          </Typography>
          <div className={classes.status}>{mapEventStatusIDToText(status)}</div>
          <div className={classes.status}>
            {remarks && <StarIcon className={classes.starIcon} />}
            {remarks}
          </div>
          {props.details.appointmentCount && (
            <div className={classes.status}>
              {`Appointment ${props.details.appointmentCount}`}
            </div>
          )}
        </div>
        <div className={classes.actionWrapper}>
          <IconButton onClick={handleClick}>
            <MoreVertIcon />
          </IconButton>
        </div>
      </div>
    </div>
  );
}

export default EventItem;
